export const isAsyncFn = (value) => {
  if (typeof value !== 'function' || !value.constructor) {
    return false;
  }

  return value.constructor.name === 'AsyncFunction';
};
